import { memo } from 'react'
import { Text } from 'ui/baseComponents/Text'
import { Stack } from 'ui/baseComponents/Stack'
import ReportMetricTrendIcon from './ReportMetricTrendIcon'
import { isAtOrBeyondThreshold, prefixPositiveSign } from '../helpers'
import { useReportTranslation } from 'utilities/i18n'

const ReportMetricTrend = ({
  value,
  trend = 0,
  trendLabel = '',
  variant = 'percent',
  noPrevData,
  iconVariant,
}) => {
  const { t } = useReportTranslation()
  const formatTrendPercent = (trend) => `${Math.abs(trend)}%`
  const formatTrendLessMore = (trend) => {
    if (trend > 0) {
      return t('report.trend.moreThan', { value: trend })
    } else {
      return t('report.trend.lessThan', { value: trend * -1 })
    }
  }

  const getFormattedTrend = () => {
    if (variant === 'lessmore') {
      return `${formatTrendLessMore(trend)} (${trendLabel})`
    } else if (variant === 'percent') {
      return `${formatTrendPercent(trend)} (${trendLabel})`
    } else {
      const trendWithPrefix = prefixPositiveSign(trend)
      return trendWithPrefix + trendLabel
    }
  }

  const trendIconVariant = isAtOrBeyondThreshold(trend) ? iconVariant : null

  return trend ? (
    <Stack alignItems="center" direction="row">
      <ReportMetricTrendIcon
        direction={trend > 0 ? 'up' : 'down'}
        variant={trendIconVariant}
      />
      <Text variant="body16">{getFormattedTrend()}</Text>
    </Stack>
  ) : (
    <Text variant="body16">
      {value === '—'
        ? ''
        : noPrevData
        ? t('report.common.noDataPrevious')
        : t('report.common.noChange')}
    </Text>
  )
}

export default memo(ReportMetricTrend)
